/**
 * Preflop Equity Chart - Compact Grid Format
 *
 * Approximate preflop all-in equity vs a random hand.
 * Values are rough approximations for demonstration purposes.
 */

import type { ChartData } from '@/types/chart';

export const preflopEquityData: ChartData = {
  version: 1,
  name: 'Preflop Equity',
  description: 'Approximate preflop all-in equity vs a random hand',
  unit: '%',
  hands: [
    // Row 0 (A): AA     AKs    AQs    AJs    ATs    A9s    A8s    A7s    A6s    A5s    A4s    A3s    A2s
    [0.852, 0.67, 0.662, 0.654, 0.646, 0.626, 0.618, 0.61, 0.6, 0.602, 0.594, 0.586, 0.576],

    // Row 1 (K): AKo    KK     KQs    KJs    KTs    K9s    K8s    K7s    K6s    K5s    K4s    K3s    K2s
    [0.653, 0.824, 0.634, 0.626, 0.618, 0.598, 0.578, 0.57, 0.562, 0.554, 0.544, 0.536, 0.526],

    // Row 2 (Q): AQo    KQo    QQ     QJs    QTs    Q9s    Q8s    Q7s    Q6s    Q5s    Q4s    Q3s    Q2s
    [0.644, 0.614, 0.799, 0.606, 0.598, 0.578, 0.558, 0.54, 0.534, 0.526, 0.516, 0.506, 0.496],

    // Row 3 (J): AJo    KJo    QJo    JJ     JTs    J9s    J8s    J7s    J6s    J5s    J4s    J3s    J2s
    [0.636, 0.606, 0.584, 0.775, 0.586, 0.566, 0.546, 0.526, 0.508, 0.5, 0.49, 0.48, 0.47],

    // Row 4 (T): ATo    KTo    QTo    JTo    TT     T9s    T8s    T7s    T6s    T5s    T4s    T3s    T2s
    [0.627, 0.596, 0.574, 0.564, 0.75, 0.556, 0.536, 0.516, 0.496, 0.478, 0.468, 0.458, 0.448],

    // Row 5 (9): A9o    K9o    Q9o    J9o    T9o    99     98s    97s    96s    95s    94s    93s    92s
    [0.605, 0.574, 0.552, 0.54, 0.53, 0.72, 0.524, 0.504, 0.484, 0.464, 0.446, 0.436, 0.426],

    // Row 6 (8): A8o    K8o    Q8o    J8o    T8o    98o    88     87s    86s    85s    84s    83s    82s
    [0.596, 0.552, 0.53, 0.518, 0.508, 0.496, 0.691, 0.502, 0.482, 0.462, 0.442, 0.424, 0.414],

    // Row 7 (7): A7o    K7o    Q7o    J7o    T7o    97o    87o    77     76s    75s    74s    73s    72s
    [0.586, 0.542, 0.51, 0.496, 0.486, 0.474, 0.472, 0.663, 0.48, 0.46, 0.44, 0.42, 0.402],

    // Row 8 (6): A6o    K6o    Q6o    J6o    T6o    96o    86o    76o    66     65s    64s    63s    62s
    [0.575, 0.532, 0.502, 0.476, 0.464, 0.452, 0.45, 0.448, 0.634, 0.458, 0.438, 0.418, 0.398],

    // Row 9 (5): A5o    K5o    Q5o    J5o    T5o    95o    85o    75o    65o    55     54s    53s    52s
    [0.578, 0.522, 0.492, 0.466, 0.444, 0.43, 0.428, 0.426, 0.424, 0.605, 0.446, 0.426, 0.406],

    // Row 10 (4): A4o    K4o    Q4o    J4o    T4o    94o    84o    74o    64o    54o    44     43s    42s
    [0.568, 0.511, 0.481, 0.455, 0.433, 0.41, 0.406, 0.404, 0.402, 0.41, 0.577, 0.414, 0.394],

    // Row 11 (3): A3o    K3o    Q3o    J3o    T3o    93o    83o    73o    63o    53o    43o    33     32s
    [0.558, 0.501, 0.47, 0.444, 0.422, 0.399, 0.386, 0.382, 0.38, 0.388, 0.376, 0.549, 0.392],

    // Row 12 (2): A2o    K2o    Q2o    J2o    T2o    92o    82o    72o    62o    52o    42o    32o    22
    [0.547, 0.49, 0.459, 0.433, 0.411, 0.388, 0.375, 0.362, 0.358, 0.366, 0.354, 0.352, 0.521],
  ],
};
